<kendo-expansionpanel [title]="'Services'"
                      [subtitle]="''"
                      [expanded]="true">
    <div style="height:300px;overflow:scroll;">
        <table>
            <tr *ngFor="let item of carrierServiceList">
                <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" (change)="saveCarrierServiceMaps(item)" style="margin:5px;transform: scale(1.5);" /></td>
                <td (click)="setCarrierServiceMap(item)">{{item.abbreviation}}</td>
                <td (click)="setCarrierServiceMap(item)">{{item.description}}</td>
            </tr>
        </table>
    </div>
</kendo-expansionpanel>
